import {
  LOAD_PRODUCTS,
  SET_LISTVIEW,
  SET_GRIDVIEW,
  UPDATE_SORT,
  SORT_PRODUCTS,
  UPDATE_FILTERS,
  FILTER_PRODUCTS,
  CLEAR_FILTERS,
} from '../actions';

const filter_reducer = (state, action) => {
  if (action.type === LOAD_PRODUCTS) {
    let maxPrice = action?.payload?.map((product) => product?.price);
    maxPrice = Math.max(...maxPrice);

    let minPrice = action.payload.map((product) => product.price);
    minPrice = Math.min(...minPrice);

    return {
      ...state,
      all_products: [...action.payload],
      filtered_products: [...action.payload],
      filters: { ...state.filters, max_price: maxPrice, price: maxPrice, min_price: minPrice },
    };
  }

  if (action.type === SET_GRIDVIEW) {
    return { ...state, grid_view: true };
  }

  if (action.type === SET_LISTVIEW) {
    return { ...state, grid_view: false };
  }

  if (action.type === UPDATE_SORT) {
    return { ...state, sort: action.payload };
  }

  if (action.type === SORT_PRODUCTS) {
    const { sort, filtered_products } = state;
    let tempProducts = [...filtered_products];

    if (sort === 'Price Low to High') {
      tempProducts = tempProducts.sort((a, b) => a.price - b.price);
    }
    if (sort === 'Price High to Low') {
      tempProducts = tempProducts.sort((a, b) => b.price - a.price);
    }
    if (sort === 'New Arrivals') {
      tempProducts = tempProducts.sort((a, b) =>
        a.createdAt.localeCompare(b.createdAt)
      );
    }
    if (sort === 'name-z') {
      tempProducts = tempProducts.sort((a, b) => b.name.localeCompare(a.name));
    }

    return { ...state, filtered_products: tempProducts };
  }

  if (action.type === UPDATE_FILTERS) {
    const { name, value } = action.payload;
    return { ...state, filters: { ...state.filters, [name]: value } };
  }

  if (action.type === FILTER_PRODUCTS) {
    const { all_products } = state;
    const { text, category,metalType, company, color, price, shipping, sleeves, collar, offers } = state.filters;
    let tempProducts = [...all_products];

    if (text) {
      tempProducts = tempProducts.filter((product) => product.name.toLowerCase().includes(text.toLowerCase()));
    }
    if (category && category !== 'all') {
      tempProducts = tempProducts.filter((product) => product.category === category);
    }
    if (company && company !== 'all') {
      tempProducts = tempProducts.filter((product) => product.company === company);
    }
    if (color && color !== 'all') {
      tempProducts = tempProducts.filter((product) => 
        product.colors.some((colorObj) => colorObj.color[0] === color)
      );
    }
    if (metalType && metalType!=="all") {
      tempProducts = tempProducts.filter((product) => product.metalType === metalType);
    }
    if (collar && collar !== 'all') {
      tempProducts = tempProducts.filter((product) => product.collar === collar);
    }
    if (price) {
      tempProducts = tempProducts.filter((product) => product.price <= price);
    }
    if (shipping) {
      tempProducts = tempProducts.filter((product) => product.shipping === shipping);
    }
    if(offers && offers!=="all"){
      tempProducts = tempProducts?.filter((product) => product?.bestOffers?._id==offers);
    }
    return { ...state, filtered_products: tempProducts };
  }

  if (action.type === CLEAR_FILTERS) {
    return {
      ...state,
      filters: {
        ...state.filters,
        text: '',
        company: 'all',
        category: 'all',
        color: 'all',
        sleeves: 'all',
        collar: 'all',
        metalType:"all",
        price: state.filters.max_price,
        shipping: false,
        offers:"all"
      },
    };
  }

  throw new Error(`No Matching "${action.type}" - action type`);
};

export default filter_reducer;